import styled, { css } from 'styled-components';
import { getColor, StyleVars } from 'core/utils/Styles';

// Import icons individually for better code splitting
import { default as Star } from 'core/icons/StarFull';
import { default as SubBox } from 'core/icons/SubBoxIcon';

export const Wrapper = styled.div`
	display: none;
	font-size: 16px;
	text-align: center;
	line-height: 1.4;
	margin-right: 28px;

	align-self: stretch;
	flex-direction: column;
	justify-content: center;
	font-weight: 600;

	@media (min-width: ${StyleVars.screenMd}) {
		display: flex;
	}
`;

export const SellWrapper = styled(Wrapper)`
	display: flex;

	@media (min-width: ${StyleVars.screenSm}) {
		margin: 0 16px;
	}

	@media (max-width: 365px) {
		margin: 0 8px;
	}
`;

export const Link = styled.a`
	color: ${getColor("gray")};
	transition: color .2s ease-in-out;
	text-decoration: underline;

	&:hover {
		color: ${getColor('black')};
	}

	svg {
		margin-right: 4px;
		fill: ${getColor('salmon')};
	}

	@media (min-width: 1024px) {
		text-decoration: none;
	}
`;

export const SmText = styled.span`
	@media (max-width: ${StyleVars.screenSm}) {
		display: none;
	}

	@media (max-width: ${StyleVars.screenXsm}) {
		display: initial;
	}

	@media (min-width: ${StyleVars.screenMd}) {
		display: none;
	}
`;

export const MdText = styled.span`
	display: none;

	@media (min-width: ${StyleVars.screenMd}) {
		display: initial;
	}

	@media (max-width: ${StyleVars.screenSm}) {
		display: initial;
	}

	@media (max-width: ${StyleVars.screenXsm}) {
		display: none;
	}
`;

const iconStyles = css`
	vertical-align: text-bottom;
	width: 19px;
	height: 19px;
`;

export const StarIcon = styled(Star)`
	${iconStyles}
`;

export const SubBoxIcon = styled(SubBox)`
	${iconStyles}

	@media (max-width: 1000px) {
		display: none;
	}
`;
